/* eslint-disable @typescript-eslint/no-explicit-any */
function gtag(...args: any[]) {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    ;(window as any).gtag(...args)
  }
}

export function trackEvent(name: string, params?: Record<string, string | number | boolean>) {
  gtag('event', name, params)
}
